import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { change as changeFieldValue } from "redux-form";
import {
	ADMINISTRATOR,
	DIRECTOR,
	FINTECH,
	HIGH_MANAGEMENT_WITH_FINANCE,
	MANAGER
} from "../../../../../utils/Roles";
import * as types from "../../../../../utils/data/dataActionTypes";
import * as dataActions from "../../../../../utils/data/dataActions";
import { CLIENT_V2 } from "../../../../../utils/data/models";
import userHasAccess from "../../../../../utils/userHasAccess";
import { RectangleSpinner } from "../../../../common/spinners";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../../enums/clientStatusTypes";
import OperationalContactsPage from "./operational-contacts/OperationalContactsPage";
import StrategicContactsPage from "./strategic-contacts/StrategicContactsPage";
class ClientContacts extends React.Component {
	/**
		* Component that will pass down the form logic to the form.
		*/

	constructor(props, context) {
		super(props, context);
		this.state = {
			disabled: false,
			currentClient: undefined,
			isDisabledForInternalContacts: false
		};
		this.isDisabled = this.isDisabled.bind(this);
		this.getIsPermittedByClientStatus = this.getIsPermittedByClientStatus.bind(
			this
		);
		this.fetchCurrentClient = this.fetchCurrentClient.bind(this);
	}

	getViewOnlyForInternalContacts(clientStatusType) {
		switch (clientStatusType) {
			case IMPLEMENTATION.value:
			case ACTIVE.value:
				return false
			case INACTIVE.value:
			case TERMINATED.value:
				return true
		}
	}
	componentDidMount() {
		this.fetchCurrentClient();
		this.isDisabled();
	}
	fetchCurrentClient() {
		this.props.activeClient && this.props.dataActions.getDataItem(CLIENT_V2, this.props.activeClient.clientId).then((res) => {
			if (res && res.type != types.GET_DATA_ITEM_SUCCESS) {
				toast(<FormattedMessage id="clients.client.errors.fetchingError" />, {
					type: toast.TYPE.ERROR,
					autoClose: true,
				});
			}
			else {
				this.setState({
					currentClient: res.payload.data
				});
			}
		});
	}
	getIsPermittedByClientStatus() {
		const { activeClient } = this.props;
		if (activeClient) {
			switch (activeClient.clientStatusType) {
				case IMPLEMENTATION.value:
					return userHasAccess(
						HIGH_MANAGEMENT_WITH_FINANCE,
						true
					);
				case ACTIVE.value:
					return userHasAccess(
						[DIRECTOR, MANAGER, ADMINISTRATOR, FINTECH],
						true
					);
				case INACTIVE.value:
					return userHasAccess(DIRECTOR);
				case TERMINATED.value:
					return userHasAccess(FINTECH);
			}
		}
	}
	isDisabled() {
		const { activeClient } = this.props;
		if (activeClient) {
			const isAuthorized = this.getIsPermittedByClientStatus();
			const isDisabledForInternalContacts = this.getViewOnlyForInternalContacts(activeClient.clientStatusType);
			this.setState({
				isDisabledForInternalContacts: isDisabledForInternalContacts,
			});
			if ((activeClient.isArchived && !userHasAccess(MANAGER)) || !isAuthorized) {
				this.setState({
					disabled: true,
				});
			}
		}
	}

	render() {
		const { disabled, currentClient, isDisabledForInternalContacts } = this.state;
		return (currentClient) ? (
			<div className="contacts">
				<OperationalContactsPage
					activeClient={currentClient}
					disabled={disabled}
					disabledInternalContacts={isDisabledForInternalContacts}
				/>
				<StrategicContactsPage
					activeClient={currentClient}
					disabled={disabled}
					changeFieldValue={this.props.changeFieldValue}
				/>
			</div>
		) : (
			<RectangleSpinner />
		);
	}
}

ClientContacts.propTypes = {
	changeFieldValue: PropTypes.func,
	activeClient: PropTypes.object,
	dataActions: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
	return {
		changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
		dataActions: bindActionCreators(dataActions, dispatch),
	};
}

function mapStateToProps(state) {
	const activeClient = state.data.clients ? state.data.clients.active : {};
	return {
		activeClient: activeClient,
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientContacts);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/ClientContacts.js